export const getCapacityPlaningCollaboratorKPI = payload => {
  return {
    type: "FETCH_CAPACITY_PLANING_COLLABORATOR_KPI",
    payload
  };
};

export const setCapacityPlaningCollaboratorTab = item => {
  return {
    type: "SET_CAPACITY_PLANING_COLLABORATOR_TAB",
    item
  };
};

export const setCapacityPlaningCollaborator = item => {
  return {
    type: "SET_CAPACITY_PLANING_COLLABORATOR",
    item
  };
};

export const setCapacityPlaningFilterSearchWord = searchWord => {
  return {
    type: "SET_CAPACITY_PLANING_PRODUCTION_FILTER_SEARCH_WORD",
    searchWord
  };
};

export const setCapacityPlaningFilterState = collaboratorState => {
  return {
    type: "SET_CAPACITY_PLANING_PRODUCTION_FILTER_STATE",
    collaboratorState
  };
};

export const setCapacityPlaningCollaboratorFilterName = searchWord => {
  return { type: "SET_CAPACITY_PLANING_COLLABORATOR_FILTER_NAME", searchWord };
};

export const getCapacityPlaningCollaboratorClient = payload => {
  return {
    type: "FETCH_CAPACITY_PLANING_COLLABORATOR_CLIENTS",
    payload
  };
};
export const setCapacityPlaningCollaboratorRole = item => {
  return {
    type: "SET_CAPACITY_PLANING_COLLABORATOR_ROLE",
    item
  };
};
export const setCapacityPlaningCollaboratorState = item => {
  return {
    type: "SET_CAPACITY_PLANING_COLLABORATOR_STATE",
    item
  };
};
export const setCapacityPlaningCollaboratorDate = item => {
  return {
    type: "SET_CAPACITY_PLANING_COLLABORATOR_DATE",
    item
  };
};
export const setCapacityPlaningCollaboratorSuperCategory = item => {
  return {
    type: "SET_CAPACITY_PLANING_COLLABORATOR_SUPER_CATEGORY",
    item
  };
};

export const setCapacityPlaningCollaboratorAnalysisPlan = item => {
  return {
    type: "SET_CAPACITY_PLANING_COLLABORATOR_ANALYSIS_PLAN",
    item
  };
};
export const setCapacityPlaningCollaboratorAnnual = item => {
  return {
    type: "SET_CAPACITY_PLANING_COLLABORATOR_ANNUAL",
    item
  };
};

export const initClientCapacityPlaningCollaborator = () => {
  return {
    type: "INIT_CLIENTS_CAPACITY_PLANING_COLLABORATOR"
  };
};

export const initCapacityPlaningProduction = () => {
  return {
    type: "INIT_CAPACITY_PLANING_PRODUCTION"
  };
};

export const getCapacityPlaningProduction = payload => {
  return {
    type: "FETCH_CAPACITY_PLANING_PRODUCTION",
    payload
  };
};

export const setCapacityPlaningListPaginationPage = pageNumber => {
  return {
    type: "SET_CAPACITY_PLANING_LIST_PAGINATION_PAGE",
    pageNumber
  };
};

export const setCapacityPlaningProductionDate = item => {
  return {
    type: "SET_CAPACITY_PLANING_PRODUCTION_DATE",
    item
  };
};

export const setCapacityPlaningProductionYear = year => {
  return {
    type: "SET_CAPACITY_PLANING_PRODUCTION_YEAR",
    year
  };
};

export const getCollaboratorFinancial = payload => {
  return {
    type: "FETCH_COLLABORATOR_FINANCIAL",
    payload
  };
};

export const setCollaboratorFinancialFilterSearchWord = searchWord => {
  return {
    type: "SET_COLLABORATOR_FINANCIAL_FILTER_SEARCH_WORD",
    searchWord
  };
};

export const initCollaboratorUID = () => {
  return {
    type: "INIT_COLLABORATOR_BY_UID"
  };
};

export const setCollaboratorRoleGrouped = selected => ({
  type: "SET_COLLABORATOR_ROLE_GROUPED",
  selected
});

export const setCollaboratorBudgetSortBy = selected => ({
  type: "SET_COLLABORATOR_BUDGET_SORT_BY_GROUPED",
  selected
});

export const setClosingDateClients = selected => ({
  type: "SET_CLOSING_DATE_CLIENTS",
  selected
});

export const setVATPeriodicity = selected => ({
  type: "SET_VAT_PERIODICITY",
  selected
});

export const getGroupedCapacityPlaningClients = data => ({
  type: "FETCH_GROUPED_CAPACITY_PLANING_CLIENTS",
  payload: data
});

export const exportCapacityDossier = data => ({
  type: "EXPORT_CAPACITY_DOSSIER",
  payload: data
});



// WEBPACK FOOTER //
// ./src/actions/actions/capacity.js